// utils/previewImage.js
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { Toast } from "vant";

export function previewImage(url) {
  // 创建一个隐藏的 img 容器
  const img = document.createElement("img");
  img.src = url;
  img.style.display = "none";
  document.body.appendChild(img);

  let viewer = null;

  const createDownloadButton = () => {
    const button = document.createElement("img");
    button.src =
      "https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/saveImageBtn.png";
    button.style.position = "absolute";
    button.style.bottom = "20px";
    button.style.left = "50%";
    button.style.width = "135px";
    button.style.height = "48px";
    button.style.transform = "translateX(-50%)";
    button.style.color = "#fff";
    button.style.zIndex = "1002";
    button.style.cursor = "pointer";

    button.addEventListener("click", () => {
      console.log("点击了下载按钮");
      if (window.__wxjs_environment) {
        Toast("请长按图片保存");
      } else {
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isAndroid || isIos) {
          DXLC_JSSDK(
            "saveFile",
            {
              type: "image",
              dataType: "url",
              dataSource: viewer.image.src,
            },
            (result) => {
              console.log(result);
              let res = null;
              if (isAndroid) {
                res = JSON.parse(result);
              } else if (isIos) {
                res = result;
              }
              if (res.code == "0") {
                Toast("图片已保存");
              } else {
                Toast(res.msg);
              }
            }
          );
        }
      }
    });

    button.setAttribute("data-viewer-download-btn", "true");
    document.body.appendChild(button);
  };

  const removeDownloadButton = () => {
    const btn = document.querySelector("[data-viewer-download-btn]");
    if (btn) btn.remove();
  };

  viewer = new Viewer(img, {
    inline: false,
    navbar: false,
    title: false,
    toolbar: false,
    tooltip: false,
    scalable: false,
    transition: true,
    fullscreen: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    viewed() {
      // 点击图片即可关闭
      viewer.image.onclick = () => {
        viewer.hide();
      };
    },
    shown() {
      createDownloadButton();
    },
    hidden() {
      removeDownloadButton();
      viewer.destroy();
      img.remove();
    },
  });

  viewer.show();
}
